<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
        </div>
        <!-- End Breadcrumb Area -->

        
    <!-- End -->   
    <div class="card">
        
        <p-table #dt2 [value]="ppaplisting" dataKey="id" [rows]="10" responsiveLayout="scroll"  [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]" [loading]="loading"
            [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['itemNumber','itemDescription','orderNumber','checker1Status']">
               <ng-template pTemplate="caption">
                <span class="p-input-icon-left d-flex align-items-center">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value,
                        'contains')" placeholder="Global Search" [(ngModel)]="filterval" />
                    <p-button type="button" class="ml-2" (click)="reset(dt2)" icon="bx bx-reset"></p-button>
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onXLSExport()"
                        class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"
                        style="margin-left: 8px;"></button>
                         <div class="add-listings-btn">
                             <span  *ngIf="role.roleName == 'Supplier'||role.roleName =='Admin'">
                            <button type="submit" class="submit_btn" (click)="sendSelectedData()" style="margin-right: 5px;">
                              Upload PPAP Document
                            </button>
                            </span>
                             <span  *ngIf="role.checker1==true||role.roleName =='Admin'" style="margin-right: 5px;">
                            <button type="submit" class="submit_btn" (click)="openModel('checker1')">
                              Checker1 Verification
                            </button>
                            </span>
							 <span  *ngIf="role.checker2==true||role.roleName =='Admin'" style="margin-right: 5px;">
                            <button type="submit" class="submit_btn" (click)="openModel('checker2')">
                              Checker2 Verification
                            </button>
                            </span>
                       <label>
  <a 
    [href]="'assets/img/Documents/F-QP-xx IFMPL PPAP Workbook Rev-00.xlsx'" 
    target="_blank"
    download="ppap-format.xlsx" 
    style="margin-left: 10px">
    Download PPAP Standard Format
  </a>
</label>
                </div>
                </span>
            </ng-template>
             <ng-template pTemplate="header">
                <tr style="width: 100%;">
                    <th>S.No</th>
                    <th>Action</th>
					<th style="min-width: 150px;">Supplier Name</th>
					 <th style="min-width: 150px;">Part Number</th>
                    <th style="min-width: 220px;">Part Description</th>
                    <th style="min-width: 150px;">Document Uploaded</th>
					 <th style="min-width: 150px;">Checker 1 Status</th>
					   <th style="min-width: 150px;">Checker 2 Status</th>
					  <th style="min-width: 150px;">Checker 1 Remark</th>
					   <th style="min-width: 150px;">Checker 2 Remark</th>
                   
                    <th style="min-width: 220px;">Order Number</th>
                    <th>PPAP Document</th>
					<th style="min-width: 150px;">Rework Doc By Checker1</th>
					<th style="min-width: 150px;">Rework Doc By Checker2</th>
                </tr>
              
            </ng-template>
            <ng-template pTemplate="body" let-customer let-i="rowIndex">
                <tr>
                    <td>{{i+1}}</td>
                       <td>
                        	<ng-container
							*ngIf="role.roleName === 'Admin' || role.roleName === 'Finance' || role.checker1 == true || role.roleName == 'Supplier'||role.checker2 == true">
							<input type="checkbox" [(ngModel)]="customer.selectedItems"
								 (change)="updateCheckboxState()"
								style="cursor: pointer;">
						</ng-container>
                    </td>
					 <td style="min-width: 150px;">
                        <span class="image-text">{{customer.supplierName || '-'}}</span>
                    </td>
					   <td style="min-width: 220px;"><span>{{customer.itemNumber|| '-'}}</span></td>
                    <td style="min-width: 250px;">
                        <span class="image-text">{{customer.itemDescription || '-'}}</span>
                    </td>
							<td>
					<button pButton pRipple type="button" *ngIf="customer.documentSigned== true" [label]="'Uploaded'"
						class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="customer.documentSigned== false" [label]="'Pending'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					</td>
						<td>
					<button pButton pRipple type="button" *ngIf="customer.checker1Status== 'Approved'" [label]="'Approved'"
						class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="customer.checker1Status== 'Pending'" [label]="'Pending'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
							<!-- <button pButton pRipple type="button" *ngIf="customer.checker1Status== 'Rejected'" [label]="'Rework'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button> -->
							<button pButton pRipple type="button" *ngIf="customer.checker1Status == 'Rejected'" 
							[label]="'Rework'" class="p-button-rounded
							p-button-info status_button" style="font-size:
							12px; padding:
							0.2rem 1rem;"></button>
					</td>
					<td>
					<button pButton pRipple type="button" *ngIf="customer.checker2Status== 'Approved'" [label]="'Approved'"
						class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="customer.checker2Status== 'Pending'" [label]="'Pending'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
							<!-- <button pButton pRipple type="button" *ngIf="customer.checker1Status== 'Rejected'" [label]="'Rework'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button> -->
							<button pButton pRipple type="button" *ngIf="customer.checker2Status == 'Rejected'" 
							[label]="'Rework'" class="p-button-rounded
							p-button-info status_button" style="font-size:
							12px; padding:
							0.2rem 1rem;"></button>
					</td>
					 <td style="min-width: 250px;">
                        <span class="image-text">{{customer.checker1Remark || '-'}}</span>
                    </td>
					 <td style="min-width: 250px;">
                        <span class="image-text">{{customer.checker2Remark || '-'}}</span>
                    </td>
						
						
                 
                    <td style="min-width: 220px;">
                        <span class="image-text">{{customer.orderNumber|| '-'}}</span>
                    </td>
                    <!-- <td style="min-width: 150px;">
                        <span class="image-text">{{customer.uploadingDate | date}}</span>
                    </td> -->
                   
                   
                    <td>
                        <a href="{{customer.fullDocumentPath}}" style="text-decoration: none;" download="{{customer.fullDocumentPath}}" target="_blank"><button pButton pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-primary p-button-text"></button></a>
                    </td>
					  <td >
                        <a href="{{customer.reworkUploadFilePath}}" style="text-decoration: none;" download="{{customer.reworkUploadFilePath}}" target="_blank"><button pButton pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-primary p-button-text"></button></a>
                    </td>
					  <td>
                        <a href="{{customer.reworkUploadFilePathChecker2}}" style="text-decoration: none;" download="{{customer.reworkUploadFilePathChecker2}}" target="_blank"><button pButton pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-primary p-button-text"></button></a>
                    </td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10">No document found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div> 

    <div class="flex-grow-1"></div>

    <app-copyrights></app-copyrights>

</div>
<p-dialog header="Upload PPAP Document" [(visible)]="documentmodal" [modal]="true" [style]="{width: '35vw'}" [draggable]="false"
	[resizable]="false" (onHide)="resetform()">
	<form [formGroup]="toolLoanForm" (ngSubmit)="submitForm()" #register="ngForm">
		<div class="add-listings-box1">
			<div class="row">
				<div class="col-lg-6 col-md-12 form-group">
					<label>Upload File<span class="star_class">*</span></label>
					<input #fileInput type="file" class="form-control"  [class.is-invalid]="(register.submitted &&
					 toolLoanForm.get('uploadDoc')?.invalid) ||
					 (toolLoanForm.get('uploadDoc')?.touched &&
					 toolLoanForm.get('uploadDoc')?.invalid)" (change)="getFile($event,'supplier')" required>
					<div class="invalid-feedback">Please Upload Document</div>

				</div>
                  	<div class="col-lg-6 col-md-12 form-group">
					<label>Remark</label>
					<input  type="text" class="form-control" formControlName="SupplierRemark" placeholder="Enter Remark" [class.is-invalid]="(register.submitted &&
					 toolLoanForm.get('SupplierRemark')?.invalid) ||
					 (toolLoanForm.get('SupplierRemark')?.touched &&
					 toolLoanForm.get('SupplierRemark')?.invalid)">
					<div class="invalid-feedback">Please Upload Document</div>

				</div>

			</div>
		 <div class="add-listings-btn form-group">
                    <div class="submit_form_group">
                        <button type="submit">Submit</button>
                    </div>
                </div>
		</div>
	</form>
</p-dialog>
<p-dialog header="Actions" [breakpoints]="{'850px' : '90vw'}" [(visible)]="display" [modal]="true"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false"
	[resizable]="false" [closable]="true" [closeOnEscape]="true">
	<div class="add-listings-box">
		<!-- <form [formGroup]="approvalForm" (ngSubmit)="onSubmit(form)" #form="ngForm"> -->

			<p-table #dt4 [value]="checkerdata" class="mb-2" dataKey="id" responsiveLayout="scroll">
				<ng-template pTemplate="header">
					<tr>
						<th>S.No.</th>
						<th>Po Number</th>
						<!-- <th>Po Type</th> -->
						<th>Part Description</th>
						<th>Part Number</th>
						<th>Remark</th>
						<th>Uploaded Document</th>
						<!-- <th>Tool New Or Shifted</th>
						<th>Tool Type </th>
						<th>Asset Code </th>
						<th>Photos</th> -->
						<!-- <th>Invoice</th> -->
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-customer let-i="rowIndex">
					<tr>
						<td>{{i+1}}</td>
						<td>
							<span>
								{{customer?.orderNumber}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.poType}}
							</span>
						</td> -->
						<td>
							<span>
								{{customer?.itemDescription}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemNumber}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.toolType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.capital || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.assetCode || '-'}}
							</span>
						</td> -->
						<td>
							<span>
								{{customer?.Remark || '-'}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.fullDocumentPath || '-'}}
							</span>
						</td>  -->

                              <td><span><a [href]="customer.fullDocumentPath" target="_blank"
								[download]="customer.fullDocumentPath">Preview</a></span></td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5">No item found.</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="row" *ngIf="role.roleName === 'Admin' ||  role.checker1==true">
				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" 
						class="form-control mb-3"   [(ngModel)]="checkerRemark" >
                </textarea>
					<div class="invalid-feedback" style="margin-top: 1.25rem">
						Remark/Reason is Required
					</div>
				</div>

				<div class="col-lg-4 col-md-12 form-group">
					<label>Upload File(In Case Of Rework)</label>
					<input #fileInput type="file" class="form-control"   (change)="getFile($event,'checker')" >
				</div>

			</div>
			<div class="col-lg-12">
				<div class="add-listings-btn" style="text-align: right">
					<button class="mr-2 success-btn" type="submit" (click)="updateStatus('approve')"
						style="background: #40b340; color: white;">
						Approve
					</button>
					<button class="mr-2 reject-btn" type="submit" (click)="updateStatus('reject')"
						style="background: #e34747; color: white;">
						Rework
					</button>
				</div>
			</div>

		<!-- </form> -->
	</div>

</p-dialog>
<p-dialog header="Actions" [breakpoints]="{'850px' : '90vw'}" [(visible)]="checker2display" [modal]="true"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false"
	[resizable]="false" [closable]="true" [closeOnEscape]="true">
	<div class="add-listings-box">
		<!-- <form [formGroup]="approvalForm" (ngSubmit)="onSubmit(form)" #form="ngForm"> -->

			<p-table #dt4 [value]="checkerdata" class="mb-2" dataKey="id" responsiveLayout="scroll">
				<ng-template pTemplate="header">
					<tr>
						<th>S.No.</th>
						<th>Po Number</th>
						<!-- <th>Po Type</th> -->
						<th>Part Description</th>
						<th>Part Number</th>
						<th>Remark</th>
						<th>Uploaded Document</th>
						<!-- <th>Tool New Or Shifted</th>
						<th>Tool Type </th>
						<th>Asset Code </th>
						<th>Photos</th> -->
						<!-- <th>Invoice</th> -->
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-customer let-i="rowIndex">
					<tr>
						<td>{{i+1}}</td>
						<td>
							<span>
								{{customer?.orderNumber}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.poType}}
							</span>
						</td> -->
						<td>
							<span>
								{{customer?.itemDescription}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemNumber}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.toolType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.capital || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.assetCode || '-'}}
							</span>
						</td> -->
						<td>
							<span>
								{{customer?.Remark || '-'}}
							</span>
						</td>
						<!-- <td>
							<span>
								{{customer?.fullDocumentPath || '-'}}
							</span>
						</td>  -->

                              <td><span><a [href]="customer.fullDocumentPath" target="_blank"
								[download]="customer.fullDocumentPath">Preview</a></span></td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5">No item found.</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="row">
				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason:</label>
					<textarea type="text" placeholder="Remark/Reason" 
						class="form-control mb-3"   [(ngModel)]="checkerRemark" >
                </textarea>
					<div class="invalid-feedback" style="margin-top: 1.25rem">
						Remark/Reason is Required
					</div>
					<!-- <hr> -->
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Upload File(In Case Of Rework)</label>
					<input #fileInput type="file" class="form-control"   (change)="getFile($event,'checker')" >
				</div>

			</div>
			<div class="col-lg-12">
				<div class="add-listings-btn" style="text-align: right">
					<button class="mr-2 success-btn" type="submit" (click)="checker2verification('approve')"
						style="background: #40b340; color: white;">
						Approve
					</button>
					<button class="mr-2 reject-btn" type="submit" (click)="checker2verification('reject')"
						style="background: #e34747; color: white;">
						Rework
					</button>
				</div>
			</div>

		<!-- </form> -->
	</div>

</p-dialog>
<!-- End Main Content Wrapper Area -->